import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { actSubjects } from "../../actprep-ui/constants/program";
import { capitalize } from "../../actprep-ui/utils/formatting";

export default function TestItemExtraFields({ formData, setFormData }) {
  return (
    <>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <FormControl fullWidth variant="standard">
          <InputLabel>Subject</InputLabel>
          <Select
            value={formData.item_metadata?.subject || ""}
            label="Subject"
            required
            onChange={(event) =>
              setFormData((formData) => {
                formData.item_metadata.subject = event.target.value;
                return { ...formData };
              })
            }
          >
            {actSubjects.map((subject) => (
              <MenuItem key={subject} value={subject}>
                {capitalize(subject)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <FormControl fullWidth variant="standard">
          <InputLabel>Testing Option</InputLabel>
          <Select
            value={
              formData.item_metadata?.automatically_select_test !== undefined
                ? formData.item_metadata?.automatically_select_test
                : ""
            }
            label="Testing Option"
            required
            onChange={(event) =>
              setFormData((formData) => {
                formData.item_metadata.automatically_select_test =
                  event.target.value;
                return { ...formData };
              })
            }
          >
            <MenuItem value={true}>Automatically Select Test</MenuItem>
            <MenuItem value={false}>Choose Test</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {formData.item_metadata.automatically_select_test === false && (
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <ModelAutoComplete
            required
            modelName={"Test"}
            label={"Test"}
            variant="standard"
            value={formData.item_metadata.test || null}
            setValue={(newTest) =>
              setFormData((formData) => {
                formData.item_metadata.test = newTest;
                return { ...formData };
              })
            }
          />
        </Grid>
      )}
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <FormControl
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={
                  formData.item_metadata?.take_test_in_challenges || false
                }
                onChange={(event, checked) => {
                  setFormData((formData) => {
                    formData.item_metadata.take_test_in_challenges = checked;
                    return { ...formData };
                  });
                }}
                color="secondary"
              />
            }
            label="Challenge Test"
          />
        </FormControl>
      </Grid>
    </>
  );
}
